// ISO 3166-1 alpha-2 country codes for the Add Event country selector.
// Order: common RoadRnr markets first, then alphabetical.
export const COUNTRIES = [
  { code: "GB", name: "United Kingdom" },
  { code: "IE", name: "Ireland" },
  { code: "US", name: "United States" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "PT", name: "Portugal" },
  { code: "CH", name: "Switzerland" },
  { code: "AT", name: "Austria" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "PL", name: "Poland" },
  { code: "CZ", name: "Czechia" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "ZA", name: "South Africa" },
  { code: "JP", name: "Japan" },
];

export function countryName(code) {
  return COUNTRIES.find((c) => c.code === code)?.name || code;
}

// Calendar country selector: the specific supported set, in the requested order.
// Reuses COUNTRIES/countryName above; codes match event.country_code and the
// /api/geocode country bias so the same location behaviour applies to every one.
export const CALENDAR_COUNTRY_CODES = [
  "GB", "IE", "US", "CA", "AU", "NZ", "FR", "DE", "ES", "IT", "NL", "BE",
];
export const CALENDAR_COUNTRIES = CALENDAR_COUNTRY_CODES.map((code) => ({
  code,
  name: countryName(code),
}));

// Visible label for the postal field per country.
export function postcodeLabel(code) {
  if (code === "GB") return "Postcode";
  if (code === "US") return "ZIP code";
  return "Postal code";
}
